import request from '../request';
let link = process.env.NODE_ENV == 'development' ? '/host' : process.env.API;
// export const getCompRecruitList = (params) => {
//   return request({
//     url: '/v1/comp_recruit_infos/index',
//     method: 'get',
//     params,
//   })
// }
// export const getCompInfo = (params) => {
//   return request({
//     url: 'v1/comp_recruit_infos/show',
//     method: 'get',
//     params,
//   })
// }
// export const getCompType = (params) => {
//   return request({
//     url: '/v1/comp_recruit_infos/categories',
//     method: 'get',
//     params,
//   })
// }
export const changeLikeState = (params) => {
  return request({
    url: '/v3/comp_recruit_infos/like',
    method: 'post',
    data: params,
  })
}
// 搜索条件接口
// export const getSearchConditions= (params) => {
//   return request({
//     url: '/v1/recruit_infos/search_conditions',
//     method: 'get',
//     params,
//   })
// }
// 城市
// export const toObtainCity = (params) => {
//   return request({
//     url: '/v1/cities/hot_cities_and_pingyin_group_cities',
//     method: 'get',
//     params,
//   })
// }

export const toObtainCityNew = params => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v2/jobs/hot_cities',
    method: 'get',
    params
  })
}

// export const renew = (params) => {
//   return request({
//     url: '/v1/recruit_infos/renew',
//     method: 'post',
//     data: params,
//   })
// }
export const recruitInfosSearch = (data) => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v2/jobs/company_list_unlogin',
    method: 'get',
    data,
  })
}
// 推荐职位工作类型
// export const allWorkHours = (params) => {
//   return request({
//     url: '/v1/recruit_infos/all_work_hours',
//     method: 'get',
//     params,
//   })
// }
// 推荐职位index api
// export const recruitInfosIndex = (params) => {
//   console.log('api======/v1/recruit_infos/index');
//   return request({
//     url: '/v1/recruit_infos/index',
//     method: 'get',
//     params,
//   })
// }


// 求职意向
export const jobIntention = (params) => {
  return request({
    url: '/v4/jobs/intentions',
    method: 'get',
    params,
  })
}

// 创建报告
export const createReport = (data) => {
  return request({
    url: `/v3/jobscan_reports`,
    method: 'POST',
    data
  })
}

// 职位相关详情（新）
export const recruitInfosNew = (token) => {
  return request({
      url: `/v3/jobs/${token}/related_info`,
      method: 'get'
  })
}

// 投递校验
export const jobDeliveryVerify = (jobToken, data) => {
  return request({
    url: `/v3/jobs/${jobToken}/delivery_check`,
    method: 'post',
    data
  })
}

// 投递简历
export const recommandDeliver = (job_token,data) => {
  return request({
    url: `/v3/jobs/${job_token}/delivery`,
    method: 'post',
    data
  })
}

// 设置求职意向
export const setJobIntention = (data) => {
  return request({
    url: '/v4/jobs/intentions',
    method: 'put',
    data,
  })
}

export const get_professions_hot_name = (params) => {
  return request({
    url: link + `/static/v1/professions/hot_name`,
    method: 'get',
    params,
  })
}

export const get_industries_list = (params) => {
  return request({
    url: link + `/static/v1/industries/list`,
    method: 'get',
    params,
  })
}

export const get_industry = (params) => {
  return request({
    url: link + `/static/v1/industries/check_box`,
    method: 'get',
    params,
  })
}
